import { useState } from "react";
import { baseApiClient } from "data/modules/api/api.client";
import { isRequestSuccessful } from "utils/Utils";
import { logError } from "utils/error";
import { FEATURE_STATUS } from "features/Account/Account.constants";
import { getUploadedFiles } from "features/ManageOfferings/modules/ManageContractInputSubSection/utils/contractUpload.utils";
import {
  PER_TIER_KYC_FIELD_KEYS,
  PER_TIER_KYC_OFFERING,
} from "./PerTierKyc.constants";

const readKeyValue = (settings, key) => settings?.[key]?.value ?? null;

export const usePerTierKycOffering = () => {
  const [offering, setOffering] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchOfferingKyc = async ({ listingUuid }) => {
    if (!listingUuid) return null;
    setLoading(true);
    try {
      const response = await baseApiClient.get(
        PER_TIER_KYC_OFFERING.SETTINGS_PATH({ listingUuid })
      );
      if (!isRequestSuccessful(response?.status)) return null;
      const settings =
        response?.data?.data ?? response?.data ?? {};
      const nextOffering = {
        [PER_TIER_KYC_FIELD_KEYS.KYC_TYPE]: readKeyValue(
          settings,
          PER_TIER_KYC_FIELD_KEYS.KYC_TYPE
        ),
        [PER_TIER_KYC_FIELD_KEYS.IS_ESIGN_ENABLED]:
          readKeyValue(settings, PER_TIER_KYC_FIELD_KEYS.IS_ESIGN_ENABLED) ??
          false,
        [PER_TIER_KYC_FIELD_KEYS.IS_DIGIO_KYC_ENABLED]:
          readKeyValue(
            settings,
            PER_TIER_KYC_FIELD_KEYS.IS_DIGIO_KYC_ENABLED
          ) ?? false,
        [PER_TIER_KYC_FIELD_KEYS.CONTRACT_PDF_URL]:
          readKeyValue(settings, PER_TIER_KYC_FIELD_KEYS.CONTRACT_PDF_URL) ??
          "",
        [PER_TIER_KYC_FIELD_KEYS.ESIGN_PLACEMENT]: readKeyValue(
          settings,
          PER_TIER_KYC_FIELD_KEYS.ESIGN_PLACEMENT
        ),
        [PER_TIER_KYC_FIELD_KEYS.KRA_CONTRACT_URL]: getUploadedFiles(
          readKeyValue(settings, PER_TIER_KYC_FIELD_KEYS.KRA_CONTRACT_URL)
        ),
        kraDisabled:
          settings?.[PER_TIER_KYC_FIELD_KEYS.IS_DIGIO_KYC_ENABLED]?.status ===
          FEATURE_STATUS.HIDDEN,
      };
      setOffering(nextOffering);
      return nextOffering;
    } catch (error) {
      logError({
        error,
        customErrorMessage: "Error while fetching offering KYC defaults",
        when: "calling fetchOfferingKyc",
        occuredAt:
          "src/features/ManageOfferings/modules/PerTierKyc/usePerTierKycOffering.js",
        severity: "blocker",
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { offering, loading, fetchOfferingKyc };
};
